import OfficeHoursPreview from './office-hours-preview';

export default OfficeHoursPreview;
